/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFilterListIcon64Regular = forwardRef('UiFilterListIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M7.5 15h49a1.5 1.5 0 0 0 0-3h-49a1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M16 32.5a1.5 1.5 0 0 1 1.5-1.5h29a1.5 1.5 0 0 1 0 3h-29a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M37.5 53h-11a1.5 1.5 0 0 1 0-3h11a1.5 1.5 0 0 1 0 3Z" })));
});
